import React, { useState, useEffect } from "react";
import { QualifierMatchesApi } from "../../../../apis/iplBattle";
import useUserInfo from "../../../../Hooks/useUserInfo";

const IPLPlayoffsBracket = (props) => {
  const [matchList, setMatchList] = useState([]);
  const { updateUserInfo } = useUserInfo();

  useEffect(() => {
    const QualifierMatches = async () => {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const result = await QualifierMatchesApi();
      if (result) {
        setMatchList(result);
      } else {
        console.log("error in MatchScheduleList API");
      }
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    };

    QualifierMatches();
  }, []);

  const [bracketData, setBracketData] = useState({
    qualifier1: {
      id: "q1",
      name: "Qualifier 1",
      team1: matchList?.[0]?.teams?.[0]?.teamLogo,
      team2: matchList?.[0]?.teams?.[1]?.teamLogo,
      status: "upcoming",
    },
    eliminator: {
      id: "e1",
      name: "Eliminator",
      team1: matchList?.[1]?.teams?.[0]?.teamLogo,
      team2: matchList?.[1]?.teams?.[1]?.teamLogo,
      status: "upcoming",
    },
    qualifier2: {
      id: "q2",
      name: "Qualifier 2",
      team1: matchList?.[2]?.teams?.[0]?.teamLogo,
      team2: matchList?.[2]?.teams?.[1]?.teamLogo,
      status: "upcoming",
    },
    final: {
      id: "f1",
      name: "Final",
      team1: matchList?.[3]?.teams?.[0]?.teamLogo,
      team2: matchList?.[3]?.teams?.[1]?.teamLogo,
      status: "upcoming",
    },
  });

  useEffect(() => {
    if (matchList?.length > 0) {
      setBracketData((prev) => ({
        ...prev,
        qualifier1: {
          ...prev.qualifier1,
          team1: matchList[0]?.teams?.[0]?.teamLogo || prev.qualifier1.team1,
          team2: matchList[0]?.teams?.[1]?.teamLogo || prev.qualifier1.team2,
        },
        eliminator: {
          ...prev.eliminator,
          team1: matchList[1]?.teams?.[0]?.teamLogo || prev.eliminator.team1,
          team2: matchList[1]?.teams?.[1]?.teamLogo || prev.eliminator.team2,
        },
        qualifier2: {
          ...prev.qualifier2,
          team1: matchList[2]?.teams?.[0]?.teamLogo || prev.qualifier2.team1,
          team2: matchList[2]?.teams?.[1]?.teamLogo || prev.qualifier2.team2,
        },
        final: {
          ...prev.final,
          team1: matchList[3]?.teams?.[0]?.teamLogo || prev.final.team1,
          team2: matchList[3]?.teams?.[1]?.teamLogo || prev.final.team2,
        },
      }));
    }
  }, [matchList]);

  const MatchCard = ({ match }) => {
    const matchIndex =
      match.id === "q1" ? 0 : match.id === "e1" ? 1 : match.id === "q2" ? 2 : 3;
    const currentMatch = matchList?.[matchIndex];

    return (

      <>


      <div
        style={{
          pointerEvents: "fill",
        }}
      >
       
        <div style={{ textAlign: "center", marginBottom: "0.5rem" }}>
          <h3
            style={{
              fontSize: "0.8rem",
              color: "white",
              margin: "0 0 0.5rem 0",
              textTransform: "uppercase",
            }}
          >
            {match.name}
          </h3>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "0.5rem",
              borderRadius: "4px",
              backgroundColor: "rgb(32 34 35)",
            }}
          >
            <img
              src={match.team1}
              alt={currentMatch?.teams?.[0]?.teamName || "Team 1"}
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <p
              style={{
                color: "white",
                fontSize: "0.7rem",
                margin: "0rem 0 0 0",
              }}
            >
              {currentMatch?.teams?.[0]?.teamName || "Team 1"}
            </p>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "0.5rem",
              borderRadius: "4px",
              backgroundColor: "rgb(32 34 35)",
            }}
          >
            <img
              src={match.team2}
              alt={currentMatch?.teams?.[1]?.teamName || "Team 2"}
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <p
              style={{
                color: "white",
                fontSize: "0.7rem",
                margin: "0rem",
              }}
            >
              {currentMatch?.teams?.[1]?.teamName || "Team 2"}
            </p>
          </div>
        </div>

        <div
          style={{
            marginTop: "0rem",
            paddingTop: "0.2rem",
            borderTop: "1px solid rgb(0, 0, 0)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.25rem",
              color: "#6c757d",
              fontSize: "0.875rem",
            }}
          ></div>
          {match.status === "completed" && (
            <div style={{ textAlign: "center", marginTop: "0.5rem" }}>
              <span
                style={{
                  backgroundColor: "#198754",
                  color: "white",
                  padding: "0.25rem 0.5rem",
                  borderRadius: "4px",
                  fontSize: "0.875rem",
                }}
              >
                {match.status === "completed" ? "Won" : "Upcoming"}
              </span>
            </div>
          )}
        </div>
      </div>
      </>
      
    );
  };

  return (
    <div
      style={{
        padding: "0rem",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          maxWidth: "400px",
          margin: "0 auto",
          padding: "0 1rem",
          overflow: "scroll",
        }}
      >
        
        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "0rem",
            marginTop: "2rem",
          }}
        >
          <h1
            style={{
              fontSize: "1rem",
              fontFamily: "press",
              color: "white",
              textTransform: "uppercase",
              marginBottom: "0.5rem",
            }}
          >
            Playoffs Schedule
          </h1>
          <button
          style={{
            background: "transparent",
            border: "none",
            height: "24px",
            position: "absolute",
            top: "0",
            right: "0",
          }}
        >
          <img style={{
            position: "fixed",
            right: "10%",
            top: "4%",
            width: "20px",
          }}
            onClick={props?.CloseFunc}
            src={"/Xicon.png"}
            className="cancel_button-sv"
          />
        </button>
        </div>

        {/* Horizontal Tournament Flow */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1.8rem",
            padding: "1rem",
            height: "65vh",
          }}
        >
          {/* Column 1: Qualifier 1 and Eliminator */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              position: "relative",
              minWidth: "80px",
            }}
          >
            <MatchCard match={bracketData.qualifier1} />
            <MatchCard match={bracketData.eliminator} />

            {/* Flow Line from Qualifier 1 to Final */}
            <div
              style={{
                position: "absolute",
                left: "5rem",
                top: "31%",
                zIndex: "-1",
                transform: "translateY(-50%)",
              }}
            >
              <svg
                width="144"
                height="132"
                viewBox="0 0 144 132"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line y1="0.5" x2="12" y2="0.5" stroke="#464646" />
                <line y1="90.5" x2="12" y2="90.5" stroke="#464646" />
                <line
                  x1="12.5"
                  y1="-2.18557e-08"
                  x2="12.5"
                  y2="91"
                  stroke="#464646"
                />
                <line x1="130" y1="75.5" x2="144" y2="75.5" stroke="#464646" />
                <line x1="130.5" y1="44" x2="130.5" y2="75" stroke="#464646" />
                <line
                  x1="13.0043"
                  y1="42.5"
                  x2="131.004"
                  y2="43.5086"
                  stroke="#464646"
                />
                <line x1="13" y1="72.5" x2="21" y2="72.5" stroke="#464646" />
                <line x1="21.5" y1="72" x2="21.5" y2="131" stroke="#464646" />
                <line x1="21" y1="131.5" x2="33" y2="131.5" stroke="#464646" />
              </svg>
            </div>

            {/* Flow Line from Eliminator to Qualifier 2 */}
            <div
              style={{
                position: "absolute",
                left: "5rem",
                top: "75%",
                zIndex: "-1",
                transform: "translateY(-50%)",
              }}
            >
              <svg
                width="75"
                height="91"
                viewBox="0 0 75 91"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line y1="0.5" x2="12" y2="0.5" stroke="#464646" />
                <line y1="90.5" x2="12" y2="90.5" stroke="#464646" />
                <line
                  x1="12.5"
                  y1="-2.18557e-08"
                  x2="12.5"
                  y2="91"
                  stroke="#464646"
                />
                <line x1="13" y1="48.5" x2="74" y2="48.5" stroke="#464646" />
                <line x1="74.5" y1="49" x2="74.5" y2="32" stroke="#464646" />
              </svg>
            </div>
          </div>

          {/* Column 2: Qualifier 2 */}
          <div
            style={{
              position: "relative",
              minWidth: "80px",
            }}
          >
            <MatchCard match={bracketData.qualifier2} />

            {/* Flow Line from Qualifier 2 to Final */}
            <div
              style={{
                position: "absolute",
                right: "-2rem",
                top: "68%",
                zIndex: "-1",
                transform: "translateY(-50%)",
              }}
            >
              <svg
                width="35"
                height="91"
                viewBox="0 0 35 91"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line y1="0.5" x2="12" y2="0.5" stroke="#464646" />
                <line y1="90.5" x2="12" y2="90.5" stroke="#464646" />
                <line
                  x1="12.5"
                  y1="-2.18557e-08"
                  x2="12.5"
                  y2="91"
                  stroke="#464646"
                />
                <line x1="12" y1="44.5" x2="35" y2="44.5" stroke="#464646" />
              </svg>
            </div>
          </div>

          {/* Column 3: Final */}
          <div style={{ minWidth: "80px" }}>
            <MatchCard match={bracketData.final} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IPLPlayoffsBracket;
